var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "control-cart",
      on: { mouseenter: _vm.showDropdownCart, mouseleave: _vm.hideDropdownCart }
    },
    [
      _c(
        "div",
        { staticClass: "control-cart__wrap", on: { click: _vm.toCheckout } },
        [
          _c(
            "div",
            { staticClass: "icon" },
            [
              _c("f-sprite-icon", {
                attrs: { "icon-link": _vm.$options.icons.IconCart.id }
              }),
              _c("ui-badge", {
                attrs: {
                  loading: _vm.UPDATE_PROGRESS,
                  text: _vm.PRODUCT_COUNT,
                  "max-width": "50"
                }
              })
            ],
            1
          ),
          _vm.amount
            ? _c("div", { staticClass: "control-cart__amount" }, [
                _c("span", [_vm._v("Сумма")]),
                _c("div", {
                  staticClass: "price-rub",
                  domProps: {
                    textContent: _vm._s(_vm.$options.filters.price(_vm.amount))
                  }
                })
              ])
            : _vm._e()
        ]
      ),
      _c(
        "div",
        { staticClass: "dropdown" },
        [
          _c(
            "ui-dropdown",
            {
              attrs: {
                visible: _vm.cartVisible,
                "overlay-height": "40",
                right: ""
              }
            },
            [
              _vm.PRODUCTS.length
                ? [
                    _vm._l(_vm.PRODUCTS, function(p) {
                      return _c("cart-item", {
                        key: p.lineIds[0],
                        attrs: { product: p }
                      })
                    }),
                    _c("ui-button", {
                      attrs: {
                        slot: "footer",
                        wide: "",
                        large: "",
                        text: "Оформить заказ"
                      },
                      on: { click: _vm.toCheckout },
                      slot: "footer"
                    })
                  ]
                : [
                    _c("page-info", {
                      attrs: {
                        subtitle: "В корзине пока нет добавленных товаров"
                      }
                    })
                  ]
            ],
            2
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }